import { BaseDataSource } from "./BaseDataSource";

export class RevenueDataSource extends BaseDataSource<any> {}



// WEBPACK FOOTER //
// /app/src/model/DataSources/RevenueDataSource.ts